











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.ProductionSite.CreateBinCommand')
    
    export class CreateBinCommand {
        constructor( sensorId: number, destinationId: number, originId: number, productId: number, name: string ) {
            
                this.sensorId = sensorId;
            
                this.destinationId = destinationId;
            
                this.originId = originId;
            
                this.productId = productId;
            
                this.name = name;
            
        }

        
            public sensorId: number;
        
            public destinationId: number;
        
            public originId: number;
        
            public productId: number;
        
            public name: string;
        
    }

    export interface ICreateBinCommand {
        
            sensorId: number;
        
            destinationId: number;
        
            originId: number;
        
            productId: number;
        
            name: string;
        
    }

    export async function createBin( command: CreateBinCommand ): Promise<CommandResult<number>>
    export async function createBin( { sensorId, destinationId, originId, productId, name }: ICreateBinCommand ): Promise<CommandResult<number>>
    export async function createBin( model: any ): Promise<CommandResult<number>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<number>;

        if(model instanceof CreateBinCommand) {
            result = await endpoint.send<CommandResult<number>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<number>>( new CreateBinCommand( model['sensorId'], model['destinationId'], model['originId'], model['productId'], model['name'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace CreateBinCommand.ExtraneousTypes {
        

        
    }

